var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable no-nested-ternary */
import { InputFieldType } from 'models/Input/InputModels';
import { useMemo, useState } from 'react';
import { PubInputField } from 'components/Shared/PubInputField/PubInputField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { LoadingSpinner } from 'components/Shared/Loading/LoadingSpinner/LoadingSpinner';
import { FabricsLookupModal } from './FabricsLookupModal';
export function FabricOptionsInput(_a) {
    var _this = this;
    var _b = _a.isEditMode, isEditMode = _b === void 0 ? true : _b, featureDescription = _a.featureDescription, featureStep = _a.featureStep, changeCodeHandler = _a.changeCodeHandler, options = _a.options, selectedValue = _a.selectedValue, showOptionalColumns = _a.showOptionalColumns, fromInfo = _a.fromInfo, modelOpenHandler = _a.modelOpenHandler;
    var _c = useState(false), isFabricModalOpen = _c[0], setIsFabricModelOpen = _c[1];
    var _d = useState(), isFabricsLoading = _d[0], setIsFabricsLoading = _d[1];
    var fabricOptions = useMemo(function () {
        var optMap = options === null || options === void 0 ? void 0 : options.map(function (option) {
            var optionCode = option.optionCode, optionDescription = option.optionDescription, minLeadTime = option.minLeadTime, gsaInd = option.gsaInd, pbSubHeading = option.pbSubHeading, prcOptionModelCode = option.prcOptionModelCode, mfgOptionModelCode = option.mfgOptionModelCode, optionRestrictionPresent = option.optionRestrictionPresent;
            return {
                optionCode: optionCode,
                optionDescription: optionDescription,
                subheading: pbSubHeading !== null && pbSubHeading !== void 0 ? pbSubHeading : '',
                gsaInd: gsaInd ? 'Y' : 'N',
                minLeadTime: minLeadTime,
                prcOptionModelCode: prcOptionModelCode,
                mfgOptionModelCode: mfgOptionModelCode,
                hasRestriction: optionRestrictionPresent
            };
        });
        setIsFabricsLoading(false);
        return optMap;
    }, [options]);
    return (_jsxs(_Fragment, { children: [isEditMode ? (_jsx(Box, { children: _jsx(PubInputField, { fieldType: InputFieldType.STRING, fieldValue: selectedValue, fieldValueUpdateHandler: undefined, borderFocus: true, makeCaratTransparent: true }) })) : null, _jsx(Button, __assign({ sx: {
                    fontSize: '12px',
                    color: 'black',
                    textDecoration: 'underline',
                    textWrap: 'nowrap',
                    ':hover': {
                        backgroundColor: !isFabricsLoading || options ? 'white' : 'transparent',
                    },
                    padding: '0px',
                }, onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!modelOpenHandler) return [3 /*break*/, 2];
                                setIsFabricsLoading(true);
                                return [4 /*yield*/, modelOpenHandler()];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                setIsFabricModelOpen(true);
                                return [2 /*return*/];
                        }
                    });
                }); } }, { children: !isEditMode ? (!isFabricsLoading ? ('View Fabric Option') : (_jsx(LoadingSpinner, { indicatorSize: 1.5, overridePosition: true }))) : isFabricsLoading && !options ? (_jsx(LoadingSpinner, { indicatorSize: 1.5, overridePosition: true })) : ('Select Fabric Option') })), isFabricModalOpen && options && (_jsx(FabricsLookupModal, { showOptionalColumns: showOptionalColumns, fromInfo: fromInfo, isEditMode: isEditMode, featureDescription: featureDescription, featureStep: featureStep, isOpen: isFabricModalOpen, setIsOpen: setIsFabricModelOpen, rowData: fabricOptions, changeCodeHandler: function (row) {
                    if (row && isEditMode) {
                        changeCodeHandler(row.code);
                        setIsFabricModelOpen(false);
                    }
                }, widthOverride: showOptionalColumns !== 'Show None' ? 50 : undefined }))] }));
}
